import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BasePageComponentWithDialogs } from 'src/app/components/base-page/base-page.component';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';

@Component({
  selector: 'app-default-withdrawal-method',
  templateUrl: './default-withdrawal-method.component.html',
  styleUrls: ['./default-withdrawal-method.component.scss']
})
export class DefaultWithdrawalMethodComponent extends BasePageComponentWithDialogs {

  constructor(
    errorDialog: MatDialog,
    public detectDeviceService: DetectDeviceService
  ) { super(errorDialog, detectDeviceService) }

  @Input() parentForm: UntypedFormGroup;
  @Input() methodInfo: any;

  countryField: any;
  usedAccountFiled: any;
  manuallyhandledFields = ["country", "used_account"]
  isAddNewAccount: boolean = false;
  selectedCountry: string = "";
  isComponentReady: boolean = false;
  additionalFields = []

  ngOnInit(): void {
    this.usedAccountFiled = this.methodInfo.fields?.filter(item => item.name === 'used_account')[0];
    const selectedUsedAccount = this.usedAccountFiled?.choices?.filter(item => item.selected)[0]?.value ?? '';
    this.parentForm.addControl("used_account", new UntypedFormControl(selectedUsedAccount, []));

    if (!!selectedUsedAccount && selectedUsedAccount !== '') {
      this.usedAccountFlow();
    }
    else {
      this.addNewAccount();
    }
    this.isComponentReady = true;
  }

  addNewAccount() {
    this.isAddNewAccount = true;
    this.isAddNewAccount = true;
    // this.countryField = this.methodInfo.fields?.filter(item => item.name === 'country')[0];
    // this.selectedCountry = this.countryField?.choices.filter(item => item.selected)[0]?.value ?? this.countryField.choices[0].value;
    this.initiateFields();
  }

  usedAccountFlow() {
    this.isAddNewAccount = false;

    this.methodInfo.fields.forEach(item => {
      if (item.name !== "used_account") {
        this.parentForm.removeControl(item.name);
      }
    })
  }

  usedAccountChange($event) {
    if ($event.target.value === "") {
      this.addNewAccount();
    }
    else if (this.isAddNewAccount) {
      this.usedAccountFlow();
      this.parentForm.get("used_account").setValue($event.target.value);
    }
    return true;
  }

  initiateFields(): void {
    try {
      const fields = this.methodInfo.fields.filter(item => item.name !== 'amount' && item.name !== 'used_account');
      fields.forEach(element => {
        element.value = element.choices?.filter(item => item.selected)[0]?.value || '';
        this.parentForm.addControl(element.name, new UntypedFormControl(element.value, element.type !== 'select' ? Validators.required : undefined));
      });

      this.additionalFields = fields;
      this.methodInfo.fields.forEach(item => {
        this.parentForm.addControl(item.name, new UntypedFormControl(item.value ?? '', [Validators.required]));
      });

    } catch (e) {
      console.error(e);
      this.openErrorDialog();
    }
  }

}
